// extracted by mini-css-extract-plugin
module.exports = {"header":"ExternalHeader__header__ZJTYs","logoWrapper":"ExternalHeader__logoWrapper__A-0bO","withoutExternalNavigation":"ExternalHeader__withoutExternalNavigation__FRxWz"};